import { useEffect, useState } from "react";

const words = ["Discover", "Listen", "Follow"];

const ValueProposition = () => {
  const [visibleWords, setVisibleWords] = useState<number[]>([]);

  useEffect(() => {
    words.forEach((_, i) => {
      setTimeout(() => {
        setVisibleWords((prev) => [...prev, i]);
      }, 600 + i * 400);
    });
  }, []);

  return (
    <section className="py-10 md:py-14 pt-[25px] pb-[25px] bg-[#fbfbfe]/[0.94]">
      <div className="container mx-auto px-6 text-center bg-[#fbfbfe]">
        <p className="text-lg font-medium tracking-tight text-foreground md:text-6xl">
          Independent music. Emerging artists. All in one place.
        </p>
        <div className="mt-4 flex items-center justify-center gap-3 text-base md:text-lg font-medium text-primary">
          {words.map((word, i) =>
          <span key={word} className="flex items-center gap-3">
              <span
              className="inline-block transition-all duration-500 ease-out font-mono font-semibold text-xl sm:text-2xl md:text-4xl"
              style={{
                opacity: visibleWords.includes(i) ? 1 : 0,
                transform: visibleWords.includes(i) ?
                "translateY(0)" :
                "translateY(12px)"
              }}>

                {word}
              </span>
              {i < words.length - 1 &&
            <span
              className="text-muted-foreground/40 transition-opacity duration-500"
              style={{ opacity: visibleWords.includes(i) ? 1 : 0 }}>

                  ·
                </span>
            }
            </span>
          )}
        </div>
      </div>
    </section>);

};

export default ValueProposition;